import { SimTypeEnum, SimTypeType } from '../../../../app-shared/models/steps/step-sim.interface';

export const SimTypeTypes: SimTypeType[] = [
  {
    id: SimTypeEnum.Standard,
    title: 'ENTITY.SIM-TYPE.STANDARD',
    images: [
      {
        alt: 'ENTITY.SIM-TYPE.STANDARD',
        src: '/assets/images/icon-mix-sim-green2.svg'
      }
    ]
  },
  {
    id: SimTypeEnum.eSim,
    title: 'ENTITY.SIM-TYPE.E-SIM',
    images: [
      {
        alt: 'ENTITY.SIM-TYPE.E-SIM',
        src: '/assets/images/eSIM.svg'
      }
    ]
  }
];
